// --- Klaviyo cart tracking ---
(function () {
  window._learnq = window._learnq || [];

  // --- Helpers ---

  function normalizeImageURL(url) {
    if (!url) return '';
    if (url.startsWith('//')) return 'https:' + url;
    return url;
  }

  function toPrice(cents) {
    return parseFloat((cents / 100).toFixed(2));
  }

  function debounce(fn, ms) {
    var timer;
    return function () {
      var args = arguments;
      clearTimeout(timer);
      timer = setTimeout(function () { fn.apply(null, args); }, ms);
    };
  }

  // --- Core tracking function ---

  function trackCartToKlaviyo(cart) {
    if (!cart || !cart.item_count) return;

    var items = cart.items.map(function (item) {
      return {
        ProductName:  item.product_title,
        ProductID:    String(item.product_id),   // string keeps it consistent with catalogue IDs
        SKU:          item.sku || '',
        Variant:      item.variant_title || '',
        ImageURL:     normalizeImageURL(item.image),
        URL:          window.location.origin + item.url,
        Price:        toPrice(item.price),
        Quantity:     item.quantity,
        LinePrice:    toPrice(item.line_price),  // useful for flows that show per-line totals
      };
    });

    window._learnq.push(['track', 'Cart Updated', {
      $value:      toPrice(cart.total_price),
      ItemCount:   cart.item_count,
      Items:       items,
      CartURL:     window.location.origin + '/cart',
      CheckoutURL: window.location.origin + '/checkout', // swap for token URL if available
    }]);
  }


  var debouncedTrack = debounce(trackCartToKlaviyo, 400);

  // --- Event listeners ---
  document.addEventListener('ajaxProduct:added', function () {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('cart.js ' + res.status);
        return res.json();
      })
      .then(debouncedTrack)
      .catch(function (e) { console.error('[Klaviyo] cart fetch error:', e); });
  });

  document.addEventListener('cart:updated', function (evt) {
    if (evt.detail && evt.detail.cart) {
      debouncedTrack(evt.detail.cart);
    } else {
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (res) {
          if (!res.ok) throw new Error('cart.js ' + res.status);
          return res.json();
        })
        .then(debouncedTrack)
        .catch(function (e) { console.error('[Klaviyo] cart fetch error:', e); });
    }
  });

})();
// --- end Klaviyo cart tracking ---


const wwOverride = () => {
  const block = document.querySelector('.wwk-sidebar--mobile');
  if (window.innerWidth < 768) {
    block.addEventListener('click', (e) => {
      e.stopPropagation();
      e.preventDefault();
      block.classList.toggle('active');
    })
  }
}


window.addEventListener("DOMContentLoaded", (event) => {
  // attribute value checker
  function attr(defaultVal, attrVal) {
    const defaultValType = typeof defaultVal;
    if (typeof attrVal !== "string" || attrVal.trim() === "") return defaultVal;
    if (attrVal === "true" && defaultValType === "boolean") return true;
    if (attrVal === "false" && defaultValType === "boolean") return false;
    if (isNaN(attrVal) && defaultValType === "string") return attrVal;
    if (!isNaN(attrVal) && defaultValType === "number") return +attrVal;
    return defaultVal;
  }
  // marquee component
  $("[tr-marquee-element='component']").each(function (index) {
    let componentEl = $(this),
      panelEl = componentEl.find("[tr-marquee-element='panel']"),
      triggerHoverEl = componentEl.find("[tr-marquee-element='triggerhover']"),
      triggerClickEl = componentEl.find("[tr-marquee-element='triggerclick']");
    let speedSetting = attr(50, componentEl.attr("tr-marquee-speed")),
      verticalSetting = attr(false, componentEl.attr("tr-marquee-vertical")),
      reverseSetting = attr(false, componentEl.attr("tr-marquee-reverse")),
      scrollDirectionSetting = attr(false, componentEl.attr("tr-marquee-scrolldirection")),
      scrollScrubSetting = attr(false, componentEl.attr("tr-marquee-scrollscrub")),
      moveDistanceSetting = -100,
      timeScaleSetting = 1,
      pausedStateSetting = false;
    if (reverseSetting) moveDistanceSetting = 100;
    let marqueeTimeline = gsap.timeline({ repeat: -1, onReverseComplete: () => marqueeTimeline.progress(1) });
    if (verticalSetting) {
      speedSetting = panelEl.first().height() / speedSetting;
      marqueeTimeline.fromTo(panelEl, { yPercent: 0 }, { yPercent: moveDistanceSetting, ease: "none", duration: speedSetting });
    } else {
      speedSetting = panelEl.first().width() / speedSetting;
      marqueeTimeline.fromTo(panelEl, { xPercent: 0 }, { xPercent: moveDistanceSetting, ease: "none", duration: speedSetting });
    }
    let scrubObject = { value: 4 };
    ScrollTrigger.create({
      trigger: "body",
      start: "top top",
      end: "bottom bottom",
      onUpdate: (self) => {
        if (!pausedStateSetting) {
          if (scrollDirectionSetting && timeScaleSetting !== self.direction) {
            timeScaleSetting = self.direction;
            marqueeTimeline.timeScale(self.direction);
          }
          if (scrollScrubSetting) {
            let v = self.getVelocity() * 0.006;
            v = gsap.utils.clamp(-60, 60, v);
            let scrubTimeline = gsap.timeline({ onUpdate: () => marqueeTimeline.timeScale(scrubObject.value) });
            scrubTimeline.fromTo(scrubObject, { value: v }, { value: timeScaleSetting, duration: 0.5 });
          }
        }
      }
    });
    function pauseMarquee(isPausing) {
      pausedStateSetting = isPausing;
      let pauseObject = { value: 1 };
      let pauseTimeline = gsap.timeline({ onUpdate: () => marqueeTimeline.timeScale(pauseObject.value) });
      if (isPausing) {
        pauseTimeline.fromTo(pauseObject, { value: timeScaleSetting }, { value: 0, duration: 0.5 });
        triggerClickEl.addClass("is-paused");
      } else {
        pauseTimeline.fromTo(pauseObject, { value: 0 }, { value: timeScaleSetting, duration: 0.5 });
        triggerClickEl.removeClass("is-paused");
      }
    }
    if (window.matchMedia("(pointer: fine)").matches) {
      triggerHoverEl.on("mouseenter", () => pauseMarquee(true));
      triggerHoverEl.on("mouseleave", () => pauseMarquee(false));
    }
    triggerClickEl.on("click", function () {
      !$(this).hasClass("is-paused") ? pauseMarquee(true) : pauseMarquee(false);
    });
  });
 
});




